/* eslint-disable import/no-cycle */
import { authService } from '../../utils/services/auth.service';
import { router } from '../../config/router/router';

const state = {
  loggingIn: false,
  loggedIn: false,
  expireAt: null,
  refreshTimeoutId: null,
};

const actions = {
  login({ dispatch, commit }, { username, password }) {
    commit('loginPending');
    authService.login(username, password)
      .then(response => {
        commit('loginSuccess');
        commit('setExpireAt', { time: response.data.expires_at });
        localStorage.setItem('auth-token', `${response.data.token_type} ${response.data.access_token}`);
        // localStorage.setItem('auth-refresh-token', response.data.refresh_token);
        router.push({ name: 'loading-screen' });
      })
      .catch(() => {
        commit('loginFailure');
        dispatch('alert/showToast', { type: 'error', message: 'Invalid credentials' }, { root: true });
      });
  },

  logout({ commit }) {
    commit('logout');
    localStorage.removeItem('vuex');
    router.push({ name: 'login' });
    authService.logout()
      .then(() => {
        localStorage.removeItem('auth-token');
        localStorage.removeItem('auth-refresh-token');
      });
  },
};

const mutations = {
  loginPending(state) {
    state.loggingIn = true;
  },

  loginSuccess(state) {
    state.loggedIn = true;
    state.loggingIn = false;
  },

  loginFailure(state) {
    state.loggedIn = false;
    state.loggingIn = false;
  },

  resetLoggingIn(state) {
    state.loggingIn = false;
  },

  logout(state) {
    state.loggedIn = false;
    state.loggingIn = false;
  },

  setExpireAt(state, { time }) {
    const date = new Date();
    date.setSeconds(date.getSeconds() + time);
    state.expireAt = date.getTime();
  },

  saveTimeoutId(state, timeoutId) {
    state.refreshTimeoutId = timeoutId;
  },

  clearTimeoutId(state) {
    state.refreshTimeoutId = null;
  },
};

const getters = {
  expireAt(state) {
    return state.expireAt;
  },
};

export const auth = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
